<template>
  <div class="m-product">
    <section class="hd">
      <img :src="require('@/assets/mobile/product.png')"/>
    </section>
    <section class="bd">
      <div class="one">
        <img :src="require('@/assets/mobile/product01.png')"/>
        <div>
          <div>
            <p>国恒充电智慧交流充电桩</p>
            <p>GHJ220032B-3/4G</p>
          </div>
          <div>
            <p>外观尺寸  260mm*260mm*99mm</p>
            <p>输入电压  176V～264V AC</p>
            <p>额定功率  7kW</p>
            <p>充电接口  七孔充电枪1</p>
            <p>IP等   级   IP55</p>
          </div>
          <div style="margin-top:.2rem;">
            <p style="margin-bottom:.12rem;font-size: 12px;line-height: 20px;">简约 时尚 智能 有序充电</p>
            <p @click="$router.push({name: 'mProductPile1'})">查看详情&nbsp;
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-arrow-right"></use>
            </svg>
            </p>
          </div>
        </div>
      </div>
      <div>
        <img :src="require('@/assets/mobile/product02.png')"/>
        <div>
          <div>
            <p>国恒充电智慧交流充电桩</p>
            <p>HD-AC7MP200</p>
          </div>
          <div>
            <p>外观尺寸  455mm*260mm*119mm</p>
            <p>输入电压  176V～264V AC</p>
            <p>额定功率  7kW</p>
            <p>充电接口  七孔充电枪1</p>
            <p>IP等   级   IP54</p>
          </div>
          <div>
            <p @click="$router.push({name: 'mProductPile'})">查看详情&nbsp;
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-arrow-right"></use>
            </svg>
            </p>
          </div>
        </div>
      </div>
      <div>
        <img :src="require('@/assets/mobile/product03.png')"/>
        <div>
          <div>
            <p>星络智慧交流充电盒</p>
            <p>HD-AC7MS100</p>
          </div>
          <div>
            <p>外观尺寸  500mm*210mm*111.5mm </p>
            <p>输入电压  187～253V AC</p>
            <p>额定功率  7kW</p>
            <p>充电接口  16A三孔插座1、32A七孔插座1</p>
            <p>IP等   级   IP32</p>
          </div>
          <div>
            <p @click="$router.push({name: 'mProductBox'})">查看详情&nbsp;
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-arrow-right"></use>
            </svg>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'product'
}
</script>
<style lang="less">
.m-product{
  background-color: #f9f9f9;
  img{
    width: 100%;
    height: 100%;
  }
  .hd{
    width: 100%;
    height: 2.34rem;
  }
  .bd{
    width: 6.94rem;
    margin: .24rem auto 0;
    >div{
      position: relative;
      height: 3.41rem;
      margin-bottom: .25rem;
      &.one{
        height: 3.79rem;
      }
      >div{
        position: absolute;
        top: .23rem;
        left: .54rem;
        >div{
          text-align: left;
          svg{
            font-size: 10px;
          }
          &:nth-child(1){
            color: #000;
            p:first-child{
              font-size: 14px;
              line-height: 18px;
            }
            p:last-child{
              font-size: 12px;
              line-height: 16px;
            }
          }
          &:nth-child(2){
            margin-top: .2rem;
            color: #000;
            font-size: 12px;
            line-height: 16px;
          }
          &:nth-child(3){
            color: #13E4E8;
            margin-top: .3rem;
            p{
              font-size: 12px;
              line-height: 16px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
